module.exports = __webpack_public_path__ + "static/media/ctrip-logo.783cc111.png";